import axios from 'axios';
import ClientOAuth2 from 'client-oauth2';
import Settings from './config';


let githubAuth = new ClientOAuth2({
    clientId: 'rockliffehall.website',
    clientSecret: 'b8919bea-8035-4001-9c08-c6af555d57c8',
    accessTokenUri: Settings.ACCESSTOKENURI,
    authorizationUri: Settings.AUTHORIZATIONURL,
    scopes: ['openid', 'profile', 'email', 'rockliffehall.api', 'rockfliffe.user', 'offline_access']
});

export default {
    login(username, password, cb, fail) {
       
        githubAuth.owner.getToken(username, password)
            .then(function (user) {
          
                cb(user);
            })
            .catch(function (response) {
          
                let body = response.body.error_description;
         
                let payload = { emailAddress: username };
                axios.post(Settings.ENDPOINT + 'api/member/initiate-migration', payload)
                    .then(response => {
                        fail('member_migration_initiated')
                    })
                    .catch(err => {

                        fail(body);

                    });


            });
    },
    validateMigration(payload, cb, fail) {
        axios.post(Settings.ENDPOINT + 'api/member/validate-migration', payload)
            .then(response => {
                cb(response.data);
            })
            .catch(err => {

                fail("not_found");

            });
    },
    refreshToken(token, cb, fail) {

        token.refresh().then(function(token) {
            cb(token);
        }).catch(function(response) {
            fail(response.body.error_description);
        });
    },
    register(payload, cb, fail) {
        axios.post(Settings.ENDPOINT + "api/account/register", payload)
            .then(response => {
                cb(response.data);
            }).catch(result => {

                fail(result.response.data.Message);
            });
    },
    update(payload, cb) {
        axios.post(Settings.ENDPOINT + "api/account/update", payload)
            .then(response => {
                cb(response.data);
            });
    },
    forgotPassword(payload, cb) {
        axios.post(Settings.ENDPOINT + "api/account/forgot-password", payload)
            .then(response => {
                cb(response.data);
            });
    },
    changePassword(payload, cb, fb) {
        axios.post(Settings.ENDPOINT + "api/account/change-password", payload)
            .then(response => {
                cb(response.data);
            }).catch(response => {
                fb(response);
            });
    },
    getSession(cb) {
        axios.get(Settings.ENDPOINT + "api/account/session")
            .then(response => {
                cb(response.data);
            });
    },
    getConfiguration(cb) {
        axios.get('/umbraco/api/account/getConfiguration')
            .then(response => {
                cb(response.data);
            });
    },


    passwordResetInitiate(payload, success, failure) {
        axios.post(Settings.ENDPOINT + 'api/password/password-reset-initiate', payload)
            .then(response => {
                success(response.data);
            })
            .catch(err => {
                failure(err.response.data);

            });
    },

    passwordResetConfirm(payload, success, failure) {
        axios.post(Settings.ENDPOINT + 'api/password/password-reset-confirm', payload)
            .then(response => {
                success(response.data);
            })
            .catch(err => {

                failure(err.response.data);

            });
    },


    passwordResetChange(payload, success, failure) {
        axios.post(Settings.ENDPOINT + 'api/password/password-reset-change', payload)
            .then(response => {
                success(response.data);
            })
            .catch(err => {

                failure(err.response.data);

            });
    }, 

}

